var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 94,
    viewBox: "0 0 101 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.90815 57.0141C0.887686 56.885 0.866436 56.7512 0.850957 56.6216C0.414661 53.4571 0.368486 50.2509 0.806618 47.0848C0.949077 46.0605 1.13771 45.0389 1.37855 44.0247C2.13859 40.8686 3.57499 37.8085 5.58462 35.2217C6.78306 33.6738 8.19138 32.2962 9.78125 31.1641C14.6595 27.6848 19.8864 28.8688 25.5217 28.0148C29.5232 27.4051 33.5112 26.5181 37.276 24.9949C41.0411 23.4719 44.5262 21.3069 47.4223 18.442C50.7487 15.1479 51.9739 11.0791 54.6069 7.45282C55.4415 6.30345 56.7719 5.07537 58.6745 4.05639C59.626 3.45272 60.6489 2.9448 61.7283 2.5699C62.8121 2.18948 63.9572 1.94156 65.1691 1.85603C70.8244 1.4465 76.5534 3.96929 80.881 7.62493C85.5029 11.5337 89.0688 16.3167 91.5265 21.5808C93.103 24.9458 94.2214 28.5004 94.8826 32.1532C96.256 39.7808 95.6174 47.8041 92.8582 55.2791C84.9008 76.8402 62.8396 95.1073 39.0831 93.5644C38.862 93.5487 38.6458 93.5322 38.4238 93.5114C38.2908 93.5072 38.1515 93.4936 38.0172 93.4794C37.3159 93.4178 36.6107 93.3315 35.9131 93.2286C34.0847 92.9545 32.2816 92.5491 30.5264 91.999C29.1454 91.5621 27.7961 91.039 26.4841 90.4288C24.9679 89.7186 23.4953 88.9609 22.0846 88.1473C20.9667 87.5111 19.8837 86.839 18.8401 86.1251C16.4584 84.5101 14.2688 82.6964 12.2844 80.6369C11.3236 79.6455 10.4096 78.5956 9.55615 77.4803C8.41254 76.0093 7.36313 74.4268 6.41104 72.722C4.56642 69.43 3.05185 65.8774 2.02027 62.1971C1.54174 60.4932 1.16447 58.7579 0.90815 57.0141Z",
    fill: "#F2F0FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.0242 37.9249V78.5121C89.0242 80.6836 87.263 82.4447 85.0915 82.4447H20.633C18.4565 82.4447 16.6953 80.6836 16.6953 78.5121V37.9249C16.6953 36.7241 17.2358 35.6484 18.0813 34.9277C18.7718 34.3424 19.6623 33.9922 20.633 33.9922H85.0915C86.0572 33.9922 86.9426 34.3424 87.6282 34.9178C88.484 35.6434 89.0242 36.7191 89.0242 37.9249Z",
    fill: "#F7C872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.0242 37.9249L79.3829 42.898L51.8692 58.2185L25.1009 42.6779L16.6953 37.9249C16.6953 36.7241 17.2358 35.6484 18.0813 34.9277C18.7718 34.3424 19.6623 33.9922 20.633 33.9922H85.0915C86.0572 33.9922 86.9426 34.3424 87.6282 34.9178C88.484 35.6434 89.0242 36.7191 89.0242 37.9249Z",
    fill: "#EDB953"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M89.0239 78.5123L51.8692 58.2188L16.6953 78.5123",
    stroke: "#EDB953",
    strokeWidth: 0.500336,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M86.7653 34.378L52.5964 15.3516L18.9531 34.378C18.9531 35.5037 19.4597 36.5125 20.2526 37.1878C20.8998 37.7366 21.7349 38.0651 22.645 38.0651H83.0784C83.9838 38.0651 84.8141 37.7366 85.4566 37.1972C86.2587 36.517 86.7653 35.5085 86.7653 34.378Z",
    fill: "#EDB953"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.1898 12.991C82.1898 13.5763 81.309 22.8526 80.2384 33.995C79.9582 36.877 79.668 39.8841 79.3778 42.9009L51.8642 58.2213L24.3857 42.6808L23.8502 33.995L22.4844 11.8151C33.5969 5.60099 82.1898 11.4851 82.1898 12.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.8502 33.9951L22.4844 11.8152C33.5969 5.60105 82.1898 11.4849 82.1898 12.991",
    stroke: "#F9E8DE",
    strokeWidth: 0.639462,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M86.6603 66.1564C91.1283 66.1564 94.7503 62.5345 94.7503 58.0665C94.7503 53.5986 91.1283 49.9766 86.6603 49.9766C82.1923 49.9766 78.5703 53.5986 78.5703 58.0665C78.5703 62.5345 82.1923 66.1564 86.6603 66.1564Z",
    fill: "url(#paint0_linear_7545_515991)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M82.625 61.4894L83.0332 60.6376C83.2061 60.2768 83.2738 59.876 83.2237 59.4801L82.9758 57.4833C82.7753 55.8549 83.6999 54.3492 85.1402 53.7405C85.1352 53.718 85.1276 53.6981 85.1252 53.6779C85.0576 53.1366 85.4435 52.6457 85.9821 52.5781C86.5233 52.5104 87.0142 52.8937 87.0819 53.4349C87.0845 53.4575 87.0819 53.4774 87.0845 53.5C88.6277 53.7379 89.8928 54.9731 90.0958 56.6015L90.3437 58.5957C90.3912 58.9939 90.5542 59.3673 90.8097 59.6755L91.416 60.402",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M84.9693 61.9993C83.1981 61.9993 82.7317 61.6763 82.7109 61.5963C82.7125 61.3743 84.0106 60.6279 86.9257 60.2664C87.6731 60.1738 88.4177 60.125 89.0793 60.125C90.8502 60.125 91.317 60.448 91.3377 60.528C91.3361 60.7499 90.038 61.4963 87.123 61.8578C86.3755 61.9502 85.6307 61.9993 84.9693 61.9993Z",
    fill: "url(#paint1_linear_7545_515991)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M89.0802 59.875V60.3761C90.0853 60.3761 90.6577 60.4876 90.9356 60.5802C90.4725 60.8748 89.1652 61.3528 87.0923 61.6097C86.3551 61.701 85.6208 61.7493 84.9693 61.7493C83.964 61.7493 83.3915 61.6378 83.1137 61.5451C83.5768 61.2505 84.8841 60.7725 86.9569 60.5157C87.6942 60.4244 88.4282 60.3761 89.0799 60.3758L89.0802 59.875ZM89.0802 59.875C88.4253 59.875 87.6802 59.9212 86.8953 60.0185C84.3759 60.3307 82.3914 61.0514 82.4628 61.6283C82.5121 62.0253 83.5225 62.2506 84.9696 62.2506C85.6244 62.2506 86.3693 62.2044 87.1542 62.1071C89.6736 61.7949 91.6581 61.0742 91.5867 60.4973C91.5374 60.1004 90.5271 59.875 89.0802 59.875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M88.1298 60.125V60.1373C88.1298 60.8013 87.5917 61.3394 86.9276 61.3394C86.3591 61.3394 85.883 60.9449 85.7578 60.4144C86.1178 60.3517 86.4984 60.295 86.8914 60.2462C87.3199 60.1927 87.736 60.1531 88.1298 60.125Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M26.4297 0.890625V2.93331",
    stroke: "#EDB953",
    strokeWidth: 1.00067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M26.4297 5.84375V7.88644",
    stroke: "#EDB953",
    strokeWidth: 1.00067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M29.9331 4.39062H27.8906",
    stroke: "#EDB953",
    strokeWidth: 1.00067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M24.9799 4.39062H22.9375",
    stroke: "#EDB953",
    strokeWidth: 1.00067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M98.0312 24.2344V25.6802",
    stroke: "#EDB953",
    strokeWidth: 0.708383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M98.0312 27.7422V29.188",
    stroke: "#EDB953",
    strokeWidth: 0.708383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M100.509 26.7109H99.0625",
    stroke: "#EDB953",
    strokeWidth: 0.708383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M97.0005 26.7109H95.5547",
    stroke: "#EDB953",
    strokeWidth: 0.708383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M8.95312 44.8672V46.5302",
    stroke: "#EDB953",
    strokeWidth: 0.814794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M8.95312 48.8984V50.5615",
    stroke: "#EDB953",
    strokeWidth: 0.814794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.8037 47.7109H10.1406",
    stroke: "#EDB953",
    strokeWidth: 0.814794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M7.77244 47.7109H6.10938",
    stroke: "#EDB953",
    strokeWidth: 0.814794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M56.4251 72.9545H10.9323C10.3871 72.9545 9.94531 72.5125 9.94531 71.9675V65.0417C9.94531 64.4965 10.3874 64.0547 10.9323 64.0547H56.4254C56.9706 64.0547 57.4124 64.4968 57.4124 65.0417V71.9675C57.4124 72.5127 56.9703 72.9545 56.4251 72.9545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M9.94531 71.9675V65.0417C9.94531 64.4965 10.3874 64.0547 10.9323 64.0547H56.4254",
    stroke: "#EDB953",
    strokeWidth: 0.250181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M44.5421 68.0078H12.9375V68.9966H44.5421V68.0078Z",
    fill: "#F7C872"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M50.3213 71.213C51.8191 71.213 53.0333 69.9988 53.0333 68.501C53.0333 67.0032 51.8191 65.7891 50.3213 65.7891C48.8236 65.7891 47.6094 67.0032 47.6094 68.501C47.6094 69.9988 48.8236 71.213 50.3213 71.213Z",
    fill: "url(#paint2_linear_7545_515991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M48.9531 68.1859L49.3886 69.2025L51.9122 67.8047",
    stroke: "white",
    strokeWidth: 0.482207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7545_515991",
    x1: 86.6603,
    y1: 49.9766,
    x2: 86.6603,
    y2: 66.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7545_515991",
    x1: 87.0243,
    y1: 60.125,
    x2: 87.0243,
    y2: 61.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7545_515991",
    x1: 50.3213,
    y1: 65.7891,
    x2: 50.3213,
    y2: 71.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailUnverified);
export default __webpack_public_path__ + "static/media/EmailUnverified.d13cd1479b28d62f37a0d91a27ef918c.svg";
export { ForwardRef as ReactComponent };